import React, { useState } from 'react';
import '../sip/Calculators.css';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

const EducationCalculator = () => {  
  const [childAge, setChildAge] = useState(10);                         
  const [currentCost, setCurrentCost] = useState(500000);
  const [inflationRate, setInflationRate] = useState(6);
  const [yearsLeft, setYearsLeft] = useState(10);
  const [expectedReturn, setExpectedReturn] = useState(10);
  const [monthlyInvestment, setMonthlyInvestment] = useState(null);
  const [futureCost, setFutureCost] = useState(null);

  const calculatePlan = () => {
    const futureEduCost = currentCost * Math.pow(1 + inflationRate / 100, yearsLeft);
    setFutureCost(futureEduCost.toFixed(2));

    const r = expectedReturn / 100 / 12;
    const n = yearsLeft * 12;

    const sip = (futureEduCost * r) / (Math.pow(1 + r, n) - 1);
    setMonthlyInvestment(sip.toFixed(2));
  };

  const data = {
    labels: ['Required Corpus', 'Inflation Impact'],
    datasets: [
      {
        data: futureCost ? [futureCost, futureCost - currentCost] : [0, 0],
        backgroundColor: ['#004aad', '#76d041'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="sip-calculator">
      <h2>Education Planning Calculator 🎓</h2>

      <div className="input-group">
        <label>Your Child's Current Age</label>
        <input type="range" min="0" max="30" step="1" value={childAge} onChange={e => setChildAge(+e.target.value)} />
        <input
          type="number"
          min="0"
          max="30"
          value={childAge}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setChildAge('');
            } else {
              setChildAge(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Current Education Cost (₹)</label>
        <input type="range" min="100" max="5000000" step="10000" value={currentCost} onChange={e => setCurrentCost(+e.target.value)} />
        <input
          type="number"
          min="100"
          max="5000000"
          value={currentCost}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setCurrentCost('');
            } else {
              setCurrentCost(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Inflation Rate (%)</label>
        <input type="range" min="1" max="15" step="0.5" value={inflationRate} onChange={e => setInflationRate(+e.target.value)} />
        <input
          type="number"
          min="1"
          max="15"
          value={inflationRate}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setInflationRate('');
            } else {
              setInflationRate(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Years Left for Education</label>
        <input type="range" min="1" max="30" value={yearsLeft} onChange={e => setYearsLeft(+e.target.value)} />
        <input
          type="number"
          min="1"
          max="30"
          value={yearsLeft}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setYearsLeft('');
            } else {
              setYearsLeft(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Expected Return Rate (%)</label>
        <input type="range" min="1" max="20" step="0.5" value={expectedReturn} onChange={e => setExpectedReturn(+e.target.value)} />
        <input
          type="number"
          min="1"
          max="20"
          value={expectedReturn}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setExpectedReturn('');
            } else {
              setExpectedReturn(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <button className="calculate-btn" onClick={calculatePlan}>Calculate</button>

      {futureCost && monthlyInvestment && (
        <div className="sip-output-section">
          <div className="result-summary">
            <h3>Planning Summary</h3>
            <p>Future Education Cost: <span>₹ {Number(futureCost).toLocaleString()}</span></p>
            <p>Monthly Investment Needed: <span>₹ {Number(monthlyInvestment).toLocaleString()}</span></p>
          </div>

          <div className="pie-chart-container">
            <h3>Cost Breakdown</h3>
            <Pie data={data} />
          </div>
        </div>
      )}
    </div>
  );
};

export default EducationCalculator;
